<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "voimaa_pakaratreenilla_osa_3";
    let title = "Näin aktivoit nukkuvan pakaran";
    let author = "Mata";
    let blogDate = "16.2.2023";
    let titlePic = "2023/kyykky1.jpg";
    let firstPara = "Artikkelisarjan kolmannessa osassa käymme läpi harjoituksia, joilla saat kyykkytreenin iskemään oikeaan kohteeseen.";

</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>

            <p>Tässä artikkelisarjan kolmannessa osassa kertaamme nukkuvan pakaran oireyhtymän sekä käymme läpi harjoituksia, joilla voit treenata pakara-aktivaatiota.</p>
            <p>Artikkelisarjan <a href="voimaa_pakaratreenilla_osa_1">ensimmäisessä osassa</a> kävimme läpi pakaran tehtävät sekä totesimme, että heikot pakarat voivat altistaa virheellisten linjausten vuoksi rasitusvammoille. Teimme myös testin, kuinka voit tarkistaa aktivoituuko pakarasi.</p>
            <p><a href="voimaa_pakaratreenilla_osa_1">Toisessa osassa</a> kävimme läpi tehokkaimmat liikkeet pakaroiden vahvistamiseen. Nämä liikkeet ovat hyödyllisiä kaikille, mutta erityisesti jos huomaat pakaroissasi heikkoutta. Liikkeet auttavat hahmottamaan ja aktivoimaan pakaroita oikealla tavalla. Muistathan kuitenkin, että täsmäliikkeet ovat apuliikkeitä, joilla ei itsessään vielä kasvateta suuria ja vahvoja pakaroita, siihen tarvitset suuria moninivelliikkeitä.</p>
            <p>Ohjelma on hyvä ohjeisharjoittelutreeniksi myös esimerkiksi juoksijalle, joka haluaa lisätä lajinomaista voimaa ylläpitääkseen hyvää juoksuasentoa.</p>
            <p>Voit tehdä liikkeet ohjeen mukaisesti sarjoina tai halutessasi kuntopiirinä niin että teet jokaista liikettä määrätyn toistomäärän ja kierroksia 1-3.</p>
       
            <h2>Nukkuvien pakaroiden aktivointi</h2>
            
            <p>Kroppa kompensoi pakaroiden heikkoa aktivaatiota käyttämällä enemmän etureisien ja selän lihaksia voiman tuottamiseen. 
                Siksi jalkatreeneissä voi olla vaikea saada tunnetta pakaroihin ja kyykyt tuntuvat enemmän alaselässä ja etureisissä. 
                Tilanne on kuitenkin mahdollista korjata oikeanlaisella treenillä.</p>

            <p>Alla olevien liikkeiden tarkoitus on herätellä pakarat ja tuoda tarvittavaa voimaa, jotta saat myös kyykyistä 
                kaiken hyödyn irti.</p>
            
             <p>Voit tehdä treenin omana harjoituksenaan, joilloin kannattaa tehdä kaikki liikkeet kiertoharjoitteluna 2-3 kertaa,
                 tai treenin alkulämmittelynä kertaalleen läpi. Voit myös poimia itsellesi sopivat liikkeet jalkatreenisi loppuun
                 avustaviksi liikkeiksi, joilla viimeistelet treenituntuman pakaroihin.</p>

            <h2>Aktivointitreeni pakaroille</h2>
            <p>Tarvitset välineeksi mielellään vastuskuminauhan, mutta liikkeet voit aivan hyvin tehdä ilmankin mikäli sinulla ei ole kuminauhaa.</p>
            <p>Lisäksi voit ottaa joihinkin liikkeisiin halutessasi lisäpainoksi käsipainot tai kahvakuulan. Keskity kuitenkin tekemään liikkeet huolellisesti hyvällä tekniikalla ja tuntumaa hakien.</p>

            <iframe width="774" height="435" src="https://www.youtube.com/embed/yEHHjFIF8qQ" title="Pakaran aktivointiliikkeitä" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

            <ol class="treeniliikkeet">
                <li>
                    <strong>Simpukka kylkimakuulla, minikuminauha x 10-15 toistoa</strong><br>
                    Aseta kuminauha polvien yläpuolelle reisien ympärille. Asetu kylkimakuulle jalat koukistettuina. 
                    Kierrä ylemmän jalan reittä pakaralihaksilla niin että ylempi polvi nousee irti.
                    Pidä jännitys keskivartalossa niin että keskivartalo pysyy linjassa. 
                    Voit tehdä liikkeen myös ilman kuminauhaa, jolloin se hieman kevenee.<br>
                    Liike haastaa erityisesti pienen ja keskimmäisen pakaralihaksen sekä lonkan ulkokiertäjät.
                </li>
                <li>
                    <strong>Jalan loitonnus kylkimakuulla x 10-15</strong><br>
                    Asetu kylkimakuulle vartalo ojennettuna. Vastuskuminauha on reisien ympärillä polven yläpuolella.
                    Ojenna ylemmän jalan reisi suoraan ylöspäin. <br>Kohdistus: Keskimmäinen pakaralihas.
                </li>
                <li><strong>Yhden jalan lantion nostot, pito yläasennossa x 6-10</strong><br>
                    Asetu selinmakuulle, jalat koukussa. Ojenna toinen jalka suoraksi ja paina 
                    toisen jalan jalkapohja tiukasti lattiaan. Ojenna lantio suoraksi. 
                    Pidä vartalo ja lantio linjassa ja ojenna lantio täysin suoraksi. 
                    Pysäytä liike hetkeksi yläasennossa.
                    Erityisesti ison pakaralihaksen erinomainen aktivointiliike.
                </li>
                <li><strong>Askelkyykky eteen ja taakse x 6+6</strong><br>
                    Astu samalla jalalla ensin askel taakse, käy alhaalla. 
                    Sitten astu samalla jalalla reipas askel eteen ja käky alhaalla. 
                    Polvi käy lähellä lattiaa mutta ei taritse mennä lattiaan asti. 
                    Pidä paino tasaisesti molemmilla jaloilla kyykätessä. Harjoittaa 
                    pääasiassa isoa pakaralihasta, mutta on myös erinomainen 
                    tasapainoharjoite ja haastaa koko lantion alueen lihaksiston.
                </li>
                <li><strong>Kyykky minikuminauhalla x 10-15</strong><br>
                    Aseta kuminauha polvien ympärille niin että kuminauha pysyy jännittyneenä koko kyykyn ajan. 
                    Tarkoitus on aktivoida pakarat niin että kuminauha pysyy koko ajan kieränä. Tämä auttaa 
                    erityisesti polen linjauksen harjoitteluun, mikäli polvilla on taipumusta kääntyä kyykätessä sisäänpäin.
                </li>
                <li><strong>Lonkan ojennus konttausasennossa kuminauhalla tai lisäpainolla x 10-15</strong><br>
                    Asetu lattialle nelinkontin, kuminauha polvien yläpuolella. Ojenna reisi vaakatasoon. 
                    Pidä samalla muu vartalo stabiilina paikallaan.
                    Liikkeen tulisi tohdistua ison pakaralihakseen.
                </li>
            </ol>

            </article>

            <section class="container">
                <h2>Lue seuraavaksi</h2>
                <div class="row">
                    <article class="blog col-xs-12 col-md-4">
                        <BlogSummary blogPath='voimaa_pakaratreenilla_osa_1' title='Osaatko aktivoida pakaralihaksesi?' titlePic='2023/pihasavotta.jpg' blogDate='' firstPara='Pakaralihakset ovat ihmisen voimakkain lihasryhmä. Artikkelisarjan ensimmäisessä osassa käymme läpi pakaralihasten tehtävät sekä pari testiä, joilla voit kokeilla osaatko aktivoida pakarasi.'></BlogSummary>
                    </article>
                    <article class="blog col-xs-12 col-md-4">
                        <BlogSummary blogPath='kyykkya-joka-paiva' title='Kyykkyä joka päivä - 26 päivää' titlePic='kyykky-800x787.jpg' blogDate='' firstPara='Levytangolla tehtävistä kyykkyliikkeistä etu- ja takakyykky ovat ne tunnetuimmat ja tehokkaimmat versiot. Olen viimeisinä vuosina yrittänyt tehdä selkäni vuoksi enemmän etukyykkyä kuin takakyykkyä, sillä etukyykky on selälle kevyempi vaihtoehto.'></BlogSummary>
                    </article>
                    <article class="blog col-xs-12 col-md-4">
                        <BlogSummary blogPath='vinkit_kestavaan_muutokseen' title='12 vinkkiä pysyvään muutokseen' titlePic='2023/healthy.jpg' firstPara='Haikailetko viimeistään kevätlumien sulaessa kadonnutta alkuvuoden intoa ja treenimotivaatiota? Lue tästä Dynamosalin vinkit kestävään muutokseen.' blogDate=''></BlogSummary>
                    </article>
                </div>
            </section>

</div>
    

{/if}

<style>


</style>
